__turbopack_context__.v({
  "className": "satisfy_96eea209-module__hW8_IW__className",
});
